import { computed } from "vue";
import { useRoute } from "vue-router";

import { GA4Tracker } from "ic-analytics";

export function useGA4Tracking() {
    const route = useRoute();
    const clientId = computed(() => route.params.clientId as string);

    return {
        trackFeatureEvent: ({
            featureEvent,
            featureCategory,
            featureContext,
            freeformValues
        }: {
            featureEvent: string;
            featureCategory: string;
            featureContext: string;
            freeformValues?: (string | number)[];
        }) => {
            const ga4TrackerInstance = GA4Tracker.getInstance();

            ga4TrackerInstance.trackFeatureEvent({
                featureEvent,
                featureCategory,
                featureContext,
                freeformValues,
                clientId: clientId.value
            });
        }
    };
}
